import React from "react";
import styled, { css } from "react-emotion";
import * as styles from "../newStyles.styles";

const H1 = styled("h1")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 28px;
  line-height: 42px;
  text-align: center;
  width: 100%;
`;
const P1 = styled("p")`
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 18px;
  margin-top: 1em;
  line-height: 24px;
  text-align: center;
  @media only screen and (min-width: 768px) {
    text-align: left;
  }
`;

const col1 = css`
  @media only screen and (min-width: 768px) {
    text-align: center;
  }
  @media only screen and (min-width: 300px) {
    text-align: center;
  }
`;

const list = css`
  /* list-style-type: none;
  @media only screen and (min-width: 768px) {
  } */
`;
const row = css`
  display: flex;
  flex-flow: row wrap;
  flex: 0 1 auto;
  padding: 30px 10px;
  justify-content: center;
`;
const offwhite = css`
  background-color: #f6fbfb;
  /* background-color: red; */
`;
const col = css`
  flex: 0 0 92%;
  margin: auto 4%;
  @media only screen and (min-width: 480px) {
    margin-left: 4%;
    margin-right: 0%;
    text-align: center;
  }
`;
const col1_4_pic = css`
  padding-top: 60px;
  @media only screen and (min-width: 480px) {
    flex: 0 0 92%;
  }
  @media only screen and (min-width: 768px) {
    flex: 0 0 36% !important;
  }
`;

const mobile_pic = css`
  margin-left: 4%;

  @media only screen and (max-width: 479px) {
    margin-left: 4%;
  }
  @media only screen and (max-width: 420px) {
    margin-left: 20%;
  }
  @media only screen and (max-width: 380px) {
    margin-left: 10%;
  }

  @media only screen and (max-width: 330px) {
    margin-left: 7%;
  }

  @media only screen and (min-width: 768px) {
    margin-left: 0%;
  }
`;

const col3 = css`
  /* background-color: #e0efef; */
  padding: 1em;
  margin: 1em;
  margin-top: 60px;
  @media only screen and (min-width: 300px) {
    text-align: left;
  }
  @media only screen and (min-width: 480px) {
    flex: 0 0 92%;
  }
  @media only screen and (min-width: 768px) {
    flex: 0 0 54%;
    text-align: left;
    margin-top: 1em;
  }
`;

const heroImage = css`
  object-fit: contain;
  width: 280px;
  /* @media only screen and (min-width: 999px) {
    width: 331px;
  } */
`;
const mobileAppBullets = css`
  display: flex;
  align-items: center;
  height: fit-content;
  align-self: center;
`;

const PowerBox = (props) => {
  if (props.reverse) {
    return (
      <div
        className={row}
        style={{ marginBottom: "0px", padding: "30px 10px" }}
      >
        <div
          style={{ maxWidth: "1200px", display: "flex", flexFlow: "row wrap" }}
        >
          <styles.H2 style={{ textAlign: "center", width: "100%" }}>
            {props.header}
          </styles.H2>

          <div
            style={{
              display: "flex",
              flexFlow: "row wrap",
              margin: "auto",
              justifyContent: "center",
            }}
            className={col}
          >
            <P1>{props.text}</P1>
            <div className={col1_4_pic + " " + col + " " + mobile_pic}>
              <img
                src={props.imgSrc}
                className={heroImage}
                alt="power-image"
              ></img>
            </div>
            <div className={col + " " + col3 + " " + mobileAppBullets}>
              {props.bullets ? (
                <ul className={list}>
                  {props.bullets.map((bullet) => {
                    return (
                      <li key={bullet}>
                        <styles.P>{bullet}</styles.P>
                      </li>
                    );
                  })}
                </ul>
              ) : null}
            </div>
          </div>
        </div>
      </div>
    );
  } else {
    return (
      <div className={row + " " + offwhite}>
        <div
          style={{ maxWidth: "1200px", display: "flex", flexFlow: "row wrap" }}
        >
          <styles.H2 style={{ textAlign: "center", width: "100%" }}>
            {props.header}
          </styles.H2>

          <div
            style={{
              display: "flex",
              flexFlow: "row wrap",
              margin: "auto",
              justifyContent: "center",
            }}
            className={col}
          >
            <P1>{props.text}</P1>
            <div className={col + " " + col3} style={{ marginLeft: "0%" }}>
              {props.bullets ? (
                <ul className={list}>
                  {props.bullets.map((bullet) => {
                    return (
                      <li key={bullet}>
                        <styles.P>{bullet}</styles.P>
                      </li>
                    );
                  })}
                </ul>
              ) : null}
            </div>
            <div>
              <div
                className={col + " " + col1_4_pic}
                style={{ marginLeft: "0%" }}
              >
                <img
                  src={props.imgSrc}
                  className={heroImage}
                  alt="power-image"
                ></img>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
};

export default PowerBox;
